import React, { useState, useCallback, useMemo } from "react";
import "./Card.css";
import Modal from "../Modal/Modal";
import VariantSelector from "./VariantSelector";
import Image from "../Image/Image";
import { Plus } from "lucide-react";

const Card = ({ title, description, image, variants, product, compact }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const variantList = useMemo(
    () => (Array.isArray(variants) ? variants.filter(Boolean) : []),
    [variants]
  );
  const minPrice = useMemo(() => {
    if (!variantList.length) return null;
    return Math.min(...variantList.map((v) => Number(v.price)));
  }, [variantList]);
  const isStop = product.is_stop_list;
  const canOrder = !isStop && variantList.length > 0;

  const containerClass = [
    "Card",
    compact ? "Card--compact" : "",
    isStop || !variantList.length ? "is-disabled" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const open = useCallback(() => {
    if (canOrder) setIsModalOpen(true);
  }, [canOrder]);

  const close = useCallback(() => setIsModalOpen(false), []);

  return (
    <>
      <button
        type="button"
        className={containerClass}
        onClick={open}
        disabled={!canOrder}
        aria-label={
          !variantList.length
            ? `${title} — варианты не настроены`
            : `Открыть ${title}`
        }
      >
        <span className="Card--Media">
          <Image src={image} alt={title} className="Card--Img" />
          {isStop && <span className="Card--StopBadge">Нет в наличии</span>}
          {!variantList.length && !isStop && (
            <span className="Card--StopBadge Card--StopBadge--soft">
              Скоро
            </span>
          )}
          {!isStop && variantList.length > 0 && !compact && (
            <span className="Card--QuickBtn" aria-hidden="true">
              <Plus size={18} />
            </span>
          )}
        </span>

        <span className="Card--Body">
          <span className="Card--Title">{title}</span>
          {!compact && description && (
            <span className="Card--Desc">{description}</span>
          )}
          <span className="Card--Foot">
            <span className="Card--Price">
              {minPrice != null && (
                <>
                  <span className="Card--PriceFrom">от</span>
                  <span className="Card--PriceValue">{minPrice} ₽</span>
                </>
              )}
              {minPrice == null && (
                <span className="Card--PriceValue Card--PriceValue--mute">
                  Цена уточняется
                </span>
              )}
            </span>
            {!compact && (
              <span
                className={`Card--SelectBtn ${
                  !canOrder ? "Card--SelectBtn--mute" : ""
                }`}
              >
                {isStop
                  ? "Недоступно"
                  : !variantList.length
                  ? "Скоро"
                  : "Выбрать"}
              </span>
            )}
          </span>
        </span>
      </button>

      <Modal isOpen={isModalOpen} onClose={close}>
        <VariantSelector
          product={product}
          variants={variantList}
          onClose={close}
        />
      </Modal>
    </>
  );
};

export default Card;
